import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useCurrentUser from './UseCurrentUser';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useCurrentUser();
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Wait for hook to initialize, then check authentication
    const checkAuth = () => {
      const token = localStorage.getItem("authToken");
      const userDetailsStr = localStorage.getItem("userDetails");

      if (!token || !userDetailsStr) {
        setAuthChecked(true);
        setIsAuthenticated(false);
        return;
      }

      try {
        const userDetails = JSON.parse(userDetailsStr);
        // Check if user is actually logged in by checking the data structure
        if (userDetails && userDetails.data && userDetails.data.customer && userDetails.data.customer.id) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Error parsing userDetails:", error);
        setIsAuthenticated(false);
      }
      
      setAuthChecked(true);
    };
    
    // Small delay to ensure useCurrentUser hook has initialized
    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, [isLoggedIn]);

  // Show loading while checking authentication
  if (!authChecked) {
    return <div>Loading...</div>;
  }

  // Check if user is authenticated
  if (!isAuthenticated) {
    // Redirect to home page if not logged in
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;

